/* Authored header and liquid-glass pointer response; no commerce interception. */
(function () {
  'use strict';
  if (window.__etHtmlChrome) return;
  window.__etHtmlChrome = true;
  var frame = 0;
  function updateHeaders() {
    frame = 0;
    var moved = window.scrollY > 60;
    document.querySelectorAll('.rug-header,.etm-header').forEach(function (header) {
      header.classList.toggle('is-scrolled', moved);
    });
  }
  function queue() { if (!frame) frame = requestAnimationFrame(updateHeaders); }
  window.addEventListener('scroll', queue, { passive: true });
  document.addEventListener('shopify:section:load', updateHeaders);
  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    var button = event.target.closest('.rug-glass,.et-nav-link,.et-discover,.theory-glass');
    if (!button) return;
    var rect = button.getBoundingClientRect();
    button.style.setProperty('--glass-x', (event.clientX - rect.left) + 'px');
    button.style.setProperty('--glass-y', (event.clientY - rect.top) + 'px');
    button.style.setProperty('--light-x', (event.clientX - rect.left) + 'px');
    button.style.setProperty('--light-y', (event.clientY - rect.top) + 'px');
  }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateHeaders, { once: true });
  else updateHeaders();
})();
